export default {
  text: 'Abrir perfil {{paymentGateway}}',
  text_generic: 'Abrir perfil de integração',
  toasts: {
    failed_to_create: 'Falha ao abrir o perfil {{paymentGateway}}',
    link_copied: 'Link copiado para a área de transferência',
    copy_failed: 'Falha ao copiar o link',
  },
};
